import { render, staticRenderFns } from "./collectionManage.vue?vue&type=template&id=a577c856&"
import script from "./collectionManage.vue?vue&type=script&lang=js&"
export * from "./collectionManage.vue?vue&type=script&lang=js&"
import style0 from "./collectionManage.vue?vue&type=style&index=0&id=a577c856&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports